module Meevo.Plugins.ControlGallery {
    'use strict';

    angular
        .module('meevo.plugins.styleGallery', []);

}